import { FC } from 'react';
import CommonPage from '../components/page/CommonPage';
import { PageTitle } from '../components/common/PageTitle';
import TerminalEdit from '../components/terminal/TerminalEdit';

const TerminalEditPage : FC= () => {
  return (
    <CommonPage selectBtnIndex={2} >
      <PageTitle title="端末編集" />
      <TerminalEdit />
    </CommonPage>
  );
};

export default TerminalEditPage;